import React from 'react';
import T from 'prop-types';
import { CheckOutlined } from '@ant-design/icons';

import ButtonRouter from '../buttonRouter';
import SignupButton from '../signupButton';
import PayButton from '../payButton';

const CheckoutButtonAdvanced = ({ isAuthenticated, isUserAdvanced, isUserProfessional, plan, size, uuid }) => {
  if (!isAuthenticated) {
    return <SignupButton block size={size} type="primary" />;
  }

  if (isUserAdvanced) {
    return (
      <ButtonRouter block icon={<CheckOutlined />} size={size} to="/settings/billing">
        Current Plan
      </ButtonRouter>
    );
  }

  if (isUserProfessional) {
    return (
      <ButtonRouter block size={size} to="/settings/billing" type="primary">
        Choose Plan
      </ButtonRouter>
    );
  }

  return (
    <PayButton plan={plan} size={size} uuid={uuid}>
      Upgrade
    </PayButton>
  );
};

CheckoutButtonAdvanced.propTypes = {
  isAuthenticated: T.bool.isRequired,
  isUserAdvanced: T.bool.isRequired,
  isUserProfessional: T.bool.isRequired,
  plan: T.string.isRequired,
  uuid: T.string.isRequired,

  size: T.string,
};

CheckoutButtonAdvanced.defaultProps = {
  size: 'large',
};

export default CheckoutButtonAdvanced;
